module.exports = __webpack_public_path__ + "img/zs_6@2x.0d0dbb16.png";